import React from "react"
import { ToastContext } from "../components/feedback/ToastBoundary"

const useToast = () => React.useContext(ToastContext)
export default useToast
